module.exports = __webpack_public_path__ + "static/media/btc-hover.6fd61be7.png";